import { render } from "./Concurrence.vue?vue&type=template&id=63df79c8"
import script from "./Concurrence.vue?vue&type=script&lang=js"
export * from "./Concurrence.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__